enum ZIndex {
  BASE_INDEX = 1,
  MAIN_NAV_CONTAINER = 2,
  MAIN_CONTENT_CONTAINER = 2,
  MAX = 2147483647,
}

export default ZIndex;
